module.exports = __webpack_public_path__ + "static/media/filterIcon.b3cc563c.svg";